import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'

export const CardConStyle = styled('div')(({ theme }) => ({
  color: colors.white,
  paddingBottom: 5,
  backgroundColor: colors.black,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  margin: theme.spacing(4),
  borderRadius: 12,
  border: `solid 0.5px ${colors.gray.gray40}`,
  minHeight: 300,
  minWidth: 300,
  '& .head': {
    padding: `${theme.spacing(1)}px 0`,
    backgroundColor: colors.yellow,
    color: colors.black,
    fontWeight: 500,
    fontFamily: 'Teko',
    fontSize: fontSizes.xlarge,
    textAlign: 'center',
    borderRadius: theme.spacing(1, 1, 0, 0),
    textTransform: 'uppercase',
    width: '100%',
  },
  '& img': {
    width: '100%',
    marginBottom: 5,
    borderRadius: '12px 12px 0 0',
  },
  '& .btn': {
    width: '95%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: colors.white,
    height: 30,
    borderRadius: 12,
    textDecoration: 'none',
    cursor: 'pointer',
    color: colors.text,
    fontWeight: 'bold',
    fontSize: fontSizes.small,
    position: 'relative',
    '&:hover': {
      backgroundColor: colors.offWhite,
    },
    '&:focus': {
      outline: 'none',
    },
  },
}))

export const ContentContainer = styled('div')(({ theme }) => ({
  color: colors.white,
  padding: theme.spacing(2),
  borderRadius: `0 0 ${theme.spacing(1)}px ${theme.spacing(1)}px`,
  backgroundColor: colors.black,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  '& .calloutImg': {
    borderRadius: 6,
    width: 100,
    marginBottom: 5,
  },
  '& .text': {
    fontSize: fontSizes.medium,
    fontWeight: 600,
    margin: '2px 0 10px 0',
    textAlign: 'center',
  },
  '& a': {
    textDecoration: 'none',
    cursor: 'pointer',
    '& .btn': {
      padding: theme.spacing(1, 0),
      borderRadius: theme.spacing(1.5),
      border: `none`,
      fontWeight: 'bold',
      color: colors.text,
      cursor: 'pointer',
      backgroundColor: colors.white,
      width: 250,
      marginBottom: 5,
      '&:hover': {
        color: '#777',
        border: `solid 2px ${colors.lightGrey}`,
      },
      '&:focus': {
        outline: 'none',
      },
    },
  },
}))

type CalloutProps = {
  border?: boolean
  leftBorderColor?: string
}

export const CalloutCon = styled('div')<CalloutProps>(
  ({ theme, border, leftBorderColor }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    '& .callout': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      background: colors.lightestGrey,
      borderRadius: 12,
      borderRight: border ? `1px solid ${colors.lightestGrey}` : 'none',
      borderTop: border ? `1px solid ${colors.lightestGrey}` : 'none',
      borderBottom: border ? `1px solid ${colors.lightestGrey}` : 'none',
      borderLeft: `8px solid ${leftBorderColor || colors.gray.gray40}`,
      margin: theme.spacing(3),
      padding: theme.spacing(2, 1),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(2),
      },
      '& .calloutOptionRow': {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        margin: theme.spacing(0, 1),
        padding: theme.spacing(1),
        borderTop: `3px solid ${colors.lightestGrey}`,
        '&:first-of-type': {
          borderTop: 0,
        },
        [theme.breakpoints.down('md')]: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          margin: theme.spacing(0, 0.5),
          padding: theme.spacing(1, 0),
        },
      },
    },
  })
)
export const CalloutInner = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& img': {
    height: 60,
    [theme.breakpoints.down('sm')]: {
      height: 40,
    },
  },
}))
export const CalloutInfoCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    // alignItems: 'center',
    width: '100%',
  },
  '& .title': {
    fontWeight: 700,
    fontSize: fontSizes.medium,
    margin: theme.spacing(0.5, 2),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      margin: '0 2px',
    },
  },
  '& .description': {
    fontWeight: 400,
    fontSize: fontSizes.small,
    margin: theme.spacing(0, 2),
    [theme.breakpoints.down('sm')]: {
      fontSize: fontSizes.small,
      textAlign: 'center',
      margin: '5px 2px',
    },
  },
}))
export const CalloutActionCol = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
}))

export const CalloutLink = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  textAlign: 'center',
  margin: theme.spacing(1),
  padding: theme.spacing(1, 3),
  borderRadius: 25,
  border: `solid 1px ${colors.helperText}`,
  fontSize: fontSizes.small,
  fontWeight: 'bold',
  color: colors.text,
  backgroundColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    background: colors.lightestGrey,
  },
  '&:focus': {
    outline: 'none',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.small,
    margin: theme.spacing(1.5),
    padding: theme.spacing(1, 2),
    width: '100%',
  },
}))
